module.exports = __webpack_public_path__ + "fonts/FreightNeoProBold-Italic.8f574e41.otf";